import React from 'react';
import { User } from '../../types';

interface ProfileFormProps {
  name: string;
  onNameChange: (name: string) => void;
  currentUser: User | null;
}

export const ProfileForm: React.FC<ProfileFormProps> = ({
  name,
  onNameChange,
  currentUser,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Name
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          className="w-full px-3 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Department
        </label>
        <input
          type="text"
          value={currentUser?.department}
          disabled
          className="w-full px-3 py-2 border rounded-md bg-gray-50"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Role
        </label>
        <input
          type="text"
          value={currentUser?.role}
          disabled
          className="w-full px-3 py-2 border rounded-md bg-gray-50"
        />
      </div>
    </div>
  );
};